var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebrtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.03em",
    height: "1em",
    "aria-hidden": "true",
    style: {
      msTransform: "rotate(360deg)",
      WebkitTransform: "rotate(360deg)",
      transform: "rotate(360deg)"
    },
    viewBox: "0 0 256 249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f60",
    d: "M142.077 191.087c0 31.806-25.782 57.592-57.588 57.592-31.81 0-57.593-25.786-57.593-57.592s25.782-57.592 57.593-57.592c31.806 0 57.588 25.786 57.588 57.592"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M255.98 110.459c0 31.802-25.782 57.592-57.588 57.592-31.81 0-57.592-25.79-57.592-57.592 0-31.807 25.781-57.597 57.592-57.597 31.806 0 57.588 25.79 57.588 57.597"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0089cc",
    d: "M115.2 109.18c0 31.803-25.781 57.593-57.592 57.593-31.802 0-57.588-25.79-57.588-57.592 0-31.806 25.786-57.597 57.588-57.597 31.81 0 57.592 25.79 57.592 57.597"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#009939",
    d: "M230.386 191.087c0 31.806-25.782 57.592-57.597 57.592-31.802 0-57.588-25.786-57.588-57.592s25.786-57.592 57.588-57.592c31.815 0 57.597 25.786 57.597 57.592"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf0000",
    d: "M185.592 57.984c0 31.806-25.786 57.593-57.592 57.593S70.408 89.79 70.408 57.984 96.194.392 128 .392s57.592 25.786 57.592 57.592"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0007",
    d: "M140.799 110.459c0 1.211.105 2.397.181 3.592 25.546-5.893 44.61-28.733 44.61-56.068 0-1.212-.105-2.402-.18-3.597-25.546 5.898-44.611 28.737-44.611 56.073"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1cd306",
    d: "M148.397 138.976c9.925 17.35 28.576 29.074 49.997 29.074 8.73 0 16.976-2 24.393-5.48-9.92-17.35-28.572-29.074-49.997-29.074-8.73 0-16.976 2.001-24.393 5.48"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f7504",
    d: "M115.2 191.087c0 14.07 5.058 26.947 13.442 36.948 8.376-10.001 13.434-22.877 13.434-36.948s-5.058-26.947-13.434-36.948c-8.384 10-13.442 22.877-13.442 36.948"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c5e87",
    d: "M34.807 162.057a57.3 57.3 0 0 0 22.801 4.715c21.21 0 39.688-11.495 49.685-28.563a57.3 57.3 0 0 0-22.801-4.712c-21.21 0-39.692 11.496-49.685 28.56"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b0001",
    d: "M70.655 53.126c-.136 1.604-.25 3.217-.25 4.859 0 27.314 19.036 50.132 44.552 56.051.13-1.604.245-3.217.245-4.855 0-27.314-19.032-50.14-44.547-56.055"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.03 183.96h-9.009c-7.953 0-14.42-6.446-14.42-14.378V88.036c0-7.933 6.467-14.384 14.42-14.384H179.99c7.954 0 14.417 6.451 14.417 14.384v81.546c0 7.932-6.463 14.379-14.417 14.379h-38.484L64.29 221.812l11.74-37.851z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebrtc);
export default __webpack_public_path__ + "static/media/webrtc.f9b930973b4e1f5121d600482941acd6.svg";
export { ForwardRef as ReactComponent };